var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVincentFlagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 0H18V18H6V0Z",
    fill: "#FFDC17"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 0H24V18H18V0Z",
    fill: "#5FBF2B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H6V18H0V0Z",
    fill: "#2E42A5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1924 11.2422L12.0908 14.627L9.63281 11.2422L12.0908 7.9541L14.1924 11.2422ZM17.0742 7.54785L14.7949 10.7764L12.5146 7.54785L14.7949 4.2002L17.0742 7.54785ZM11.3105 7.54785L9.03027 10.7178L6.75 7.54785L9.20801 4.25977L11.3105 7.54785Z",
    fill: "#5FBF2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVincentFlagIcon);
export default __webpack_public_path__ + "static/media/vincentFlagIcon.655449546c8f5a52153896a595f381e7.svg";
export { ForwardRef as ReactComponent };